import React from "react";
import { registerSheet } from "@components/sheet-provider";
import { JobSheetContent } from "../sheet-contents/job-sheet/JobSheetContent";
import { SearchSheetContent } from "../sheet-contents/search-sheet/SearchSheetContent";
import { PatientSheetContent } from "../sheet-contents/patient-sheet/PatientSheetContent";
import { JobRequestSheetContent } from "../sheet-contents/job-request-sheet/JobRequestSheetContent";
import { QuickstartSheetContent } from "../sheet-contents/quickstart-sheet/QuickstartSheetContent";
import { ArticleSheetContent } from "../sheet-contents/article-sheet/ArticleSheetContent";
import { ArticleSheetActions } from "../sheet-contents/article-sheet/ArticleSheetActions";
import { MaterialTraceabilitySheetContent } from "../sheet-contents/article-sheet/MaterialTraceabilitySheetContent";
import { JobSheetActions } from "../sheet-contents/job-sheet/JobSheetActions";
import { PatientSheetActions } from "../sheet-contents/patient-sheet/PatientSheetActions";

export type {
	SheetContentProps,
	SheetHeaderProps,
} from "@components/sheet-provider";

export { sheetRegistry, registerSheet } from "@components/sheet-provider";

registerSheet(
	"job",
	JobSheetContent as React.ComponentType<any>,
	JobSheetActions as React.ComponentType<any>
);
registerSheet("search", SearchSheetContent);
registerSheet(
	"patient",
	PatientSheetContent,
	PatientSheetActions as React.ComponentType<any>
);
registerSheet(
	"job_request",
	JobRequestSheetContent as React.ComponentType<any>
);
registerSheet("quickstart", QuickstartSheetContent);
registerSheet(
	"article",
	ArticleSheetContent as React.ComponentType<any>,
	ArticleSheetActions as React.ComponentType<any>
);
registerSheet(
	"material_traceability",
	MaterialTraceabilitySheetContent as React.ComponentType<any>
);
